<template>
  <el-input
    :type="inputType"
    v-model="inputContent"
    :maxlength="inputLength"
    @input="$emit('input', $event)"
    placeholder=" "
    clearable
    ref="pwdInput"
    @focus="handleFocus"
    @blur="handleBlur"
  >
    <template #suffix>
      <i
        class="icon"
        @click="handleIconClick($event)"
        :class="
          (isFocus) && inputContent.length
            ? inputType === 'text'
              ? 'HSIconfont hs-icon-show icon-focus'
              : 'HSIconfont hs-icon-hide icon-focus'
            : inputType === 'text'
              ? 'HSIconfont hs-icon-show icon-blur'
              : 'HSIconfont hs-icon-hide icon-blur'
        "
      ></i>
    </template>
  </el-input>
</template>

<script>
export default {
  name: "pwdinput",
  props: ["value", "maxlength"],
  watch: {
    value() {
      this.inputContent = this.value;
    },
    maxlength() {
      this.inputLength = this.maxlength;
    },
  },
  data() {
    return {
      inputType: "password",
      inputContent: this.value,
      inputLength: this.maxlength,
      isFocus: false, // 用于跟踪输入框的焦点状态
    };
  },
  methods: {
    inputTypeChange() {
      this.inputType = this.inputType === "text" ? "password" : "text";
    },
    handleIconClick(event) {
      // 阻止默认行为和冒泡
      event.preventDefault();
      
      // 切换输入类型
      this.inputTypeChange();
      this.$nextTick(()=>{
        this.$refs.pwdInput.blur();
        this.$refs.pwdInput.hovering=false;
        this.$refs.pwdInput.focused=false;
        this.isFocus = false; // 手动更新焦点状态
        this.$forceUpdate()
      })

    },
    handleFocus() {
      this.isFocus = true;
    },
    handleBlur() {
      setTimeout(() => {
        this.isFocus = false;
      }, 0);
    }
  }
};
</script>

<style lang="scss" scoped>
.icon {
  cursor: pointer;
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1; /* 确保图标在输入框之上 */
}

.icon-focus {
  right: 20px;
}

.icon-blur {
  right: 10px;
}
</style>
